import React from "react";

/* Was an uncontrolled stack of antd Row/Col with loose Radio buttons, rendered
   inline on the create page. The recurrence now lives in the Custom modal, so
   this is a controlled panel of it. Previous version in git history. */

/**
 * Daily panel of the Custom recurrence modal.
 *
 *   value: { type: "every" | "weekday", interval }
 *
 * Styles come from CustomRecurrenceModal.css, which the modal imports.
 */
export default function DailyForm({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <div className="crm-section">
      <div className="crm-section-title">Repeat On:</div>

      <label className="crm-row">
        <input
          type="radio"
          name="crm-daily-type"
          checked={value.type === "every"}
          onChange={() => set({ type: "every" })}
        />
        <span className="crm-row-label">Every</span>
        <input
          type="number"
          min="1"
          className="crm-num"
          value={value.interval}
          // Choosing the number is choosing the mode it belongs to.
          onFocus={() => set({ type: "every" })}
          onChange={(e) => set({ type: "every", interval: e.target.value })}
        />
        <span className="crm-row-label">day(s)</span>
      </label>

      <label className="crm-row">
        <input
          type="radio"
          name="crm-daily-type"
          checked={value.type === "weekday"}
          onChange={() => set({ type: "weekday" })}
        />
        <span className="crm-row-label">Every weekday</span>
      </label>
    </div>
  );
}
